<template>
  <div class="filter-container filter-container-boolean flex-row">
    <div class="filter-op">
      <menu-wrapper>
        <template #menu-button="{toggleMenu}">
          <button tabindex="-1" class="btn-filter-operator" @click="toggleMenu">
            <div :class="['icon24', nativeFilterIconClass]" />
          </button>
        </template>
        <template #menu-content>
          <template v-for="(item, i) in filterOperators" :key="i">
            <menu-item
              class="filter-operator-item"
              :class="item.enumValue === operatorValue ? 'active' : ''"
              :icon="['icon24', item.icon]"
              @menu-item-click="filterOperatorItemClick(item)"
            >
              {{ item?.enumText }}
            </menu-item>
          </template>
        </template>
      </menu-wrapper>
    </div>
    <div class="filter-value flex flex-center filter-checkbox">
      <ms-checkbox v-model="filterValue" @change="filterHeaderHandle({operator: operatorValue, value: filterValue})" />
    </div>
  </div>
</template>
<script>
import {defineComponent} from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';

export default defineComponent({
  name: 'MsThOptionBoolean',
  components: {
    MenuItem,
    MenuWrapper,
  },
  extends: msThOptionBase,
  props: {},
  setup(props, {emit}) {
    const {
      nativeFilterIconClass,
      operatorValue,
      filterOperators,
      filterHeaderHandle,
      removeFilter,
      filterValue,
      filterOperatorItemClick,
      updateFilterValue,
    } = setup(props, {
      emit,
    });

    // Hooks

    return {
      nativeFilterIconClass,
      operatorValue,
      filterOperators,
      filterValue,
      filterHeaderHandle,
      removeFilter,
      filterOperatorItemClick,
      updateFilterValue,
    };
  },
});
</script>
<style lang="scss">
.ms-th-filter {
  .filter-container-boolean {
    display: flex;
    justify-content: center;
  }
}
.filter-checkbox {
  .ms-checkbox {
    margin-right: 29px !important;
  }
}
</style>
